import { Controller } from "@hotwired/stimulus";

// Stimulus controller for debounced search functionality
export default class extends Controller {
  static targets = ["input"];
  static values = { delay: { type: Number, default: 300 } };

  connect() {
    this.timeout = null;
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  search() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    this.timeout = setTimeout(() => {
      // Find the closest form and submit it
      const form = this.element.closest("form");
      if (form) {
        form.requestSubmit();
      }
    }, this.delayValue);
  }

  // Handle clear event when input is empty
  clear() {
    const form = this.element.closest("form");
    if (form && this.element.value === "") {
      form.requestSubmit();
    }
  }
}
